module.exports = __webpack_public_path__ + "static/media/loader_tail_spin.f9c5ce77.svg";